import { render, staticRenderFns } from "./ActivityStreamCard.vue?vue&type=template&id=becfda22&scoped=true"
import script from "./ActivityStreamCard.vue?vue&type=script&lang=js"
export * from "./ActivityStreamCard.vue?vue&type=script&lang=js"
import style0 from "./ActivityStreamCard.vue?vue&type=style&index=0&id=becfda22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becfda22",
  null
  
)

export default component.exports